import { ReceiptSelectItemFlightSegment } from '../../interfaces/receipt-select/receipt-select-item-flight-segment';
import { ReceiptSelectItemModel } from '../../interfaces/receipt-select/receipt-select-item-model';

/**
 * 航空券／EMD表示内容情報データモデルの実装。
 */
export class ReceiptSelectItemModelImpl implements ReceiptSelectItemModel {
  itemTitle;
  ancillaryCode?: string;
  toolTipContent?: string;
  displayOrder?: number;
  flightList: Array<ReceiptSelectItemFlightSegment> = [];
  serviceTargetType?: string | undefined;
  constructor(_itemTitle: string, private isShowName: boolean, ancillaryCode?: string, serviceTargetType?: string) {
    this.itemTitle = _itemTitle;
    this.ancillaryCode = ancillaryCode;
    this.serviceTargetType = serviceTargetType;
  }

  get isETicket(): boolean {
    // 航空券表示のときはサービス種別が未設定である
    return !this.ancillaryCode;
  }

  get isShownName(): boolean {
    return this.isShowName;
  }
}
